module.exports = __webpack_public_path__ + "img/icon_arrow_gray_right.acab40e3.svg";